import { mmFetchWithResponse } from './mmFetchWithResponse';

const shopperMarketingApi = {
    getVendorPromotionOptions: async () => {
        const url = 'api/marketing/v1/shopperMarketing/vendorPromotions/options';
        return mmFetchWithResponse(url);
    },
    getVendorPromotions: async () => {
        const url = 'api/marketing/v1/shopperMarketing/vendorPromotions';
        return mmFetchWithResponse(url);
    },
    getVendorPromotionStatuses: async () => {
        const url = 'api/marketing/v1/shopperMarketing/vendorPromotions/statuses';
        return mmFetchWithResponse(url);
    },
    getVendorPromotionSkus: async (id) => {
        const url = `api/marketing/v1/shopperMarketing/vendorPromotions/${id}/skus`;
        return mmFetchWithResponse(url);
    },
    getVendorPromotionTypes: async () => {
        const url = 'api/marketing/v1/shopperMarketing/vendorPromotions/types';
        return mmFetchWithResponse(url);
    },
    confirmVendorPromotions: async (key) => {
        const url = 'api/marketing/v1/shopperMarketing/vendorPromotions/skus/confirm';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ key }),
        });
    },
    createVendorPromotion: async (formData) => {
        const url = 'api/marketing/v1/shopperMarketing/vendorPromotions';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(formData),
        });
    },
    cloneVendorPromotion: async (id, formData) => {
        const url = `api/marketing/v1/shopperMarketing/vendorPromotions/${id}/clone`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(formData),
        });
    },
    uploadVendorPromotions: async (vendorPromotionID, data) => {
        const formData = new FormData();
        formData.append('vendorPromotionID', vendorPromotionID);
        formData.append('file', data.file);

        const url = 'api/marketing/v1/shopperMarketing/vendorPromotions/skus/upload';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
    },
    updateVendorPromotion: async (id, sendParams) => {
        const url = `api/marketing/v1/shopperMarketing/vendorPromotions/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    updateVendorPromotionSku: async (id, skuID, sendParams) => {
        const url = `api/marketing/v1/shopperMarketing/vendorPromotions/${id}/skus/${skuID}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    removeVendorPromotionSku: async (id, skuID) => {
        const url = `api/marketing/v1/shopperMarketing/vendorPromotions/${id}/skus/${skuID}`;
        return mmFetchWithResponse(url, {
            method: 'DELETE',
        });
    },
};

export { shopperMarketingApi };
